@if (isPreviewActive) {
	<section>
		<div class="preview-message">
			<span class="type-bold type-20">{{ 'Branding_PreviewMessage' | translate }}</span>
			@if (isGuestMode) {
				<span class="type-italic">{{ 'Branding_PreviewButtonLabel_Public_Msg' | translate }}</span>
			}
		</div>
		<a class="btn-preview" vbBtnPrimary uiSref="portal.admin.system-settings.branding-settings" [uiParams]="{ accountId: accountId, isGuestMode: false }">
			{{ 'Branding_PreviewExitLabel' | translate }}
		</a>
	</section>
}
